import { GridLoader } from 'react-spinners'

const Spinner: React.FC<Record<string, never>> = () => <GridLoader color="#fff" size={30} />

export default Spinner
